export const DEFAULT_TITLES = {
    amount: 'Сумма',
    term: 'Срок',
    payment: 'Платёж',
};

export const DEFAULT_BTN_TEXT = 'Получить';
